import React from 'react';
import {
    GALLERY,
    IMAGE,
    PARAGRAPH,
    SUBTITLE,
    TITLE,
    ZOOMABLEIMAGE,
    ORDEREDLIST,
    UNORDEREDLIST
} from "../../../../components/sectionTypes";
import Gallery from "../containers/sections/Gallery";
import List from "../containers/sections/List";
import Paragraph from "../containers/sections/Paragraph";
import Image from "../containers/sections/Image";

export default function Sections({sections}) {

    return (
        Object.keys(sections).map(function (key) {
            const section = sections[key];
            const {type, content} = section;
            if (PARAGRAPH === type || SUBTITLE === type || TITLE === type) {
                return (
                    <Paragraph
                        key={key}
                        id={key}
                        content={content}
                        type={type}/>);
            }

            if (IMAGE === type || ZOOMABLEIMAGE === type) {
                return (
                    <Image
                        key={key}
                        id={key}
                        url={section.url}
                        type={type}/>
                );
            }

            if (GALLERY === type) {
                return (
                    <Gallery
                        key={key}
                        id={key}
                        slides={section.slides}/>
                );
            }

            if (ORDEREDLIST === type || UNORDEREDLIST === type) {
                const {prepend, append, elements} = section;
                return (
                    <List
                        key={key}
                        id={key}
                        type={type}
                        prepend={prepend}
                        append={append}
                        elements={elements}/>
                );
            }

            return <p key={key}>{type}</p>;

        })
    );
}


// WEBPACK FOOTER //
// ./src/admin/components/editor/components/Sections.js